export class NumberParser {
  private group;

  private decimal;

  private numeral;

  private index;

  constructor(locale: string) {
    const parts = new Intl.NumberFormat(locale).formatToParts(12345.6);
    const numerals = [
      ...new Intl.NumberFormat(locale, { useGrouping: false }).format(9876543210),
    ].reverse();
    const index = new Map(numerals.map((d, i) => [d, i]));
    this.group = new RegExp(`[${parts.find((d) => d.type === "group")?.value}]`, "g");
    this.decimal = new RegExp(`[${parts.find((d) => d.type === "decimal")?.value}]`);
    this.numeral = new RegExp(`[${numerals.join("")}]`, "g");
    this.index = (d: string) => index.get(d) ?? 0;
  }

  parse(string: string) {
    let value = string;
    // eslint-disable-next-line
    return (value = value
      .trim()
      .replace(this.group, "")
      .replace(this.decimal, ".")
      // @ts-expect-error if cast to string this doesn't work anymore, pls help! // TODO
      .replace(this.numeral, this.index))
      ? Number(value)
      : NaN;
  }
}
